import { createSlice } from "@reduxjs/toolkit";

/**
 * @param {Object | null} state - current state. Can be null or the object that includes live radio with regions
 * @param {Object} action - supported actions update
 * @return {Object | null} - newly updated state, or the current state.
 */
const liveRadioSlice = createSlice({
    name: "liveRadio",
    initialState: null,
    reducers: {
        update: (state, action) => {
            return {
                ...state,
                ...action.payload,
            };
        },
    },
});

export const { update: live_radio_update } = liveRadioSlice.actions;

export default liveRadioSlice.reducer;
